// extracted by mini-css-extract-plugin
export default {"PhotoCapture":"PhotoCapture_PhotoCapture__j6Qqt"};